<!--Main Content Area-->
<main aria-label="Main Content"
    class="container-fluid pk-gradient-bg">
    <div class="row justify-content-center">
        <a class="logo-auth-top col-12"
            role="button"
            (click)="onLoginLinkClick()"
            aria-label="Invoice">
            <img src="assets/images/PurchaseLogo.svg"
                class="img-fluid logo-d p-3">
        </a>
        <div class="col-lg-6 col-xl-5 column-vh d-flex justify-content-center align-items-center">
            <div class="pk-login-signup-right-card">
                <div class="mb-sm-1 mb-3 img_graphics">
                    <img src="assets/images/auth-left-img.png"
                        class="img-fluid">
                </div>
                <h1 class="mb-2 mt-3 text-black">Welcome!</h1>
                <p class="mb-0 lead w-75 fw-medium">An all-in-one AI platform to digitize invoices, automate payments,
                    and sync accounting.</p>
            </div>
        </div>
        <div class="col-lg-6 col-xl-5 column-vh d-flex justify-content-center align-items-center">
            <div class="pk-login-signup-card">
                <div class="pk-login-form pmd-card border-none p-4 p-lg-5 shadow-md">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="border-top-primary-dark mx-3 py-3">
                <div class="row justify-content-between">
                    <div class="col-md-auto">
                        <div class="pmd-site-info text-md-right">
                            <p class="text-sm"
                                tabindex="0"> &copy; {{currentYear}}
                                Purchase
                                by <b>Petpooja</b>
                            </p>
                        </div>
                    </div>
                    <div class="col-md-auto">
                        <ul class="pmd-footer-nav pmd-footer-nav-divider">
                            <li>
                                <a href="javascript: void(0);"
                                    target="_blank"
                                    routerLink="/terms"
                                    class="text-sm"
                                    aria-label="Press enter to open terms of use page">
                                    Terms of Use
                                </a>
                            </li>
                            <li>
                                <a href="javascript: void(0);"
                                    target="_blank"
                                    class="text-sm"
                                    routerLink="/privacy"
                                    aria-label="Press enter to open privacy policy page">
                                    Privacy Policy
                                </a>
                            </li>
                            <li>
                                <a href="javascript: void(0);"
                                    target="_blank"
                                    class="text-sm"
                                    routerLink="/refund-policy"
                                    aria-label="Press enter to open Refund Policy page">
                                    Refund
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>
<!--/.Main Content Area-->